<span [ngSwitch]="language">
    <span *ngSwitchCase="'fr'" class="fi fi-fr"></span>
    <span *ngSwitchCase="'en'" class="fi fi-gb"></span>
    <span *ngSwitchCase="'es'" class="fi fi-es"></span>
    <span *ngSwitchCase="'de'" class="fi fi-de"></span>
</span>
